/**
 * What a prompt sent while the agent is working should do.
 *
 * Queueing waits for the current turn to finish; steering redirects it now.
 * The setting picks the default, and the modifier does the opposite for one
 * message — so whichever a user picks, the other is always one key away and
 * neither choice is a trip to Settings.
 */
import type { FollowUpBehavior } from "@afar-research/contracts/settings";

export type FollowUpAction = "queue" | "steer";

export function resolveFollowUpAction(input: {
  readonly setting: FollowUpBehavior;
  /** The platform's modifier was held on send. */
  readonly inverted: boolean;
  /** Steering needs a turn to redirect; without one the prompt simply starts it. */
  readonly canSteer: boolean;
}): FollowUpAction {
  const wanted: FollowUpAction =
    input.setting === "steer"
      ? input.inverted
        ? "queue"
        : "steer"
      : input.inverted
        ? "steer"
        : "queue";
  return wanted === "steer" && !input.canSteer ? "queue" : wanted;
}
